export default __webpack_public_path__ + "static/media/review-dinh-thu-oan-khuat-ghost-of-war-15965120886610.3df8f8b4.png";